import React, { FC } from "react";
import classes from "./MediaEpisodes.module.css";
import { motion } from "framer-motion";
import SkeletonCardsGrid from "../SkeletonCardsGrid";

type MediaEpisodesProps = {
  mediaDetails: any;
  windowWidth: number;
  season: number | string | null;
  handleMouseDown: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleMouseUp: (
    event: React.MouseEvent<HTMLButtonElement>,
    seasonNo: number
  ) => void;
  handleMouseMove: () => void;
  seasonLoading: boolean;
  seasonData: any;
};

const MediaEpisodes: FC<MediaEpisodesProps> = ({
  mediaDetails,
  windowWidth,
  season,
  handleMouseDown,
  handleMouseMove,
  handleMouseUp,
  seasonLoading,
  seasonData,
}) => {
  return (
    <>
      <motion.div
        className={classes.seasons_drag_section}
        style={{
          gridTemplateColumns: `repeat(${mediaDetails?.result?.seasons?.length}, 100px)`,
        }}
        drag="x"
        dragConstraints={{
          top: 0,
          left: -(windowWidth <= 800
            ? 10 +
              mediaDetails?.result?.seasons?.length * 100 +
              mediaDetails?.result?.seasons?.length * 10 +
              mediaDetails?.result?.seasons?.length * 1 -
              windowWidth
            : window.innerWidth * 0.05 +
              mediaDetails?.result?.seasons?.length * 100 +
              mediaDetails?.result?.seasons?.length * 10 +
              mediaDetails?.result?.seasons?.length * 1 -
              windowWidth),
          right: 0,
          bottom: 0,
        }}
        transition={{
          type: "spring",
          damping: 100,
          stiffness: 100,
        }}
      >
        {mediaDetails?.result?.seasons?.map((dataItem: any, idx: any) => {
          return (
            <button
              className={`${classes.season} ${
                dataItem?.season_number === season && classes.active
              }`}
              onMouseDown={(event) => handleMouseDown(event)}
              onMouseUp={(event) =>
                handleMouseUp(event, dataItem?.season_number)
              }
              onMouseMove={handleMouseMove}
            >
              {dataItem?.name}
            </button>
          );
        })}
      </motion.div>

      {seasonLoading ? (
        <SkeletonCardsGrid />
      ) : (
        <div className={classes.carousel_container}>
          <motion.div
            className={classes.section_image_cards}
            style={{
              gridTemplateColumns: `repeat(${
                seasonData?.result[`season/${season}`]?.episodes?.length
              }, 227px)`,
            }}
            drag="x"
            dragConstraints={{
              top: 0,
              left: -(windowWidth <= 800
                ? 10 +
                  seasonData?.result[`season/${season}`]?.episodes?.length *
                    227 +
                  seasonData?.result[`season/${season}`]?.episodes?.length *
                    10 +
                  seasonData?.result[`season/${season}`]?.episodes?.length * 1 -
                  windowWidth
                : window.innerWidth * 0.05 +
                  seasonData?.result[`season/${season}`]?.episodes?.length *
                    227 +
                  seasonData?.result[`season/${season}`]?.episodes?.length *
                    10 +
                  seasonData?.result[`season/${season}`]?.episodes?.length * 1 -
                  windowWidth),
              right: 0,
              bottom: 0,
            }}
            transition={{
              type: "spring",
              damping: 100,
              stiffness: 100,
            }}
          >
            {seasonData?.result[`season/${season}`]?.episodes?.map(
              (dataItem: any, idx: number) => (
                <div className={classes.episode_card}>
                  <div className={classes.episode_img}>
                    <img
                      // https://image.tmdb.org/t/p/w227_and_h127_bestv2/
                      // https://media.themoviedb.org/t/p/w454_and_h254_bestv2
                      src={`https://image.tmdb.org/t/p/w227_and_h127_bestv2/${dataItem?.still_path}`}
                      alt=""
                      className={classes.episode_image}
                    />
                  </div>
                  <div className={classes.episode_content}>
                    <p className={classes.episode_title}>
                      S{dataItem?.season_number}.E{dataItem?.episode_number} ~{" "}
                      {dataItem?.name}
                    </p>
                    <p className={classes.episode_air_date}>
                      {new Date(dataItem?.air_date).toLocaleDateString(
                        "en-US",
                        {
                          weekday: "short",
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        }
                      )}
                    </p>
                    <p className={classes.episode_overview}>
                      {dataItem?.overview}
                    </p>
                    <p className={classes.episode_rating}></p>
                  </div>
                </div>
              )
            )}
          </motion.div>
        </div>
      )}
    </>
  );
};

export default MediaEpisodes;
